import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { API_BASE } from "../../services/api";
import useLocalStorage from "../../hooks/useLocalStorage";
import { useAddToHomescreenPrompt } from "../../hooks/useTriggerPwaPromt";
import { isIntelled } from "../../services/device";
import { InstallInstruction, VersionTag } from "../../components";
import sodennLogo from "../../assets/sodenn.png";
import styles from "./login.module.scss";

const Login = () => {
  const [identifier, setIdentifer] = useState("");
  const navigate = useNavigate();
  const [storedValue, setValue] = useLocalStorage("identifier");
  const [prompt, promptToInstall] = useAddToHomescreenPrompt();
  const [isVisible, setVisibleState] = useState(false);
  
  const onSubmit = async () => {
    if (identifier) {
      try {
        let member = await fetch(`${API_BASE}/member/id/${identifier}`, {
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        });

        member = await member.json();

        if (member) {
          setValue(member.identifier);
          navigate(`/carnet/${identifier}`);
        }
      } catch (e) {
        console.log("Error***", e);
      }
    }
  };

  useEffect(() => {
    if (storedValue) {
      navigate(`/carnet/${storedValue}`);
    }
  }, [storedValue]);

  useEffect(() => {
    if (prompt) {
      setVisibleState(true);
    }
  }, [prompt]);

  return (
    <div className={styles.container}>
      <div className={styles.logoContainer}>
        <img src={sodennLogo} className={styles.logo} alt="sodenn logo" />
      </div>
      <VersionTag/>
      {!isIntelled() ? <InstallInstruction /> : null}
      <div className={styles.innerContainer}>
        <label className={styles.text}>Cédula (sin guion)</label>
        <input
          name="identifier"
          value={identifier}
          className={styles.input}
          onChange={(e) => setIdentifer(e.target.value)}
        />
        <button className={styles.button_shadow} onClick={onSubmit}>
          Iniciar
        </button>
        {isVisible ? (
          <button
            className={styles.button}
            id="pwa_install"
            onClick={promptToInstall}
            // disabled={needToReAskPermission}
          >
            Instalar App
          </button>
        ) : null}

        <div className={styles.privacyPolicy}>
          <a
            href="https://appsodenn.sociedadplus.com/privacy.html"
            target="_blank"
            rel="noreferrer"
          >
            Privacy Policy - Política de privacidad
          </a>
          <hr />
          <a
            href="https://appsodenn.sociedadplus.com/terms_and_condition.html"
            target="_blank"
            rel="noreferrer"
          >
            Terms and condition - Termino y condiciones
          </a>
        </div>
      </div>
    </div>
  );
};

export default Login;
